import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserSearchConditionStudent } from '@agent-ds/shared/interfaces/user-search-condition-student';

@Injectable({
  providedIn: 'root',
})
export class UserSearchConditionApiService {
  constructor(private http: HttpClient) {}

  getStudentConditions(): Observable<UserSearchConditionStudent[]> {
    return this.http.get<UserSearchConditionStudent[]>(
      '/api/user-search-conditions/student',
    );
  }

  saveStudentCondition(condition: {
    name: string;
    searchCondition: any;
  }): Observable<any> {
    return this.http.post('/api/user-search-conditions/student', condition);
  }

  deleteStudentCondition(id: number): Observable<any> {
    return this.http.delete(`/api/user-search-conditions/student/${id}`);
  }
}
